import React, { useState } from "react";
import { Space, Typography, Button } from "antd";
import { CloseOutlined, FilterOutlined, ClearOutlined } from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";

const { Text } = Typography;

const ActiveFilters = ({ filters, onRemoveFilter, onClearAll }) => {
  const [removingFilter, setRemovingFilter] = useState(null);

  const statusOptions = [
    { value: "NEW", label: "Yeni", color: "#1890ff" },
    { value: "IN_PROGRESS", label: "Devam Ediyor", color: "#faad14" },
    { value: "COMPLETED", label: "Tamamlandi", color: "#52c41a" },
    { value: "CANCELLED", label: "Iptal Edildi", color: "#ff4d4f" },
    { value: "FAILED", label: "Basarisiz", color: "#8c8c8c" },
  ];

  const getStatusColor = (status) => {
    return statusOptions.find(opt => opt.value === status)?.color || '#1890ff';
  };

  const handleRemove = (filterType) => {
    setRemovingFilter(filterType);
    setTimeout(() => {
      onRemoveFilter(filterType);
      setRemovingFilter(null);
    }, 200);
  };

  const activeFilterCount = [
    filters.status,
    filters.customerIds?.length > 0,
    filters.dateRange?.length === 2
  ].filter(Boolean).length;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      style={{
        marginBottom: 16,
        padding: '12px 16px',
        backgroundColor: '#fafafa',
        borderRadius: 8,
        border: '1px solid #f0f0f0'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
        <Space wrap size={[8, 8]}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FilterOutlined style={{ color: '#1890ff' }} />
            <Text strong style={{ fontSize: 13 }}>Aktif Filtreler</Text>
            <span style={{
              backgroundColor: '#1890ff',
              color: 'white',
              borderRadius: '50%',
              width: 20,
              height: 20,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 600
            }}>
              {activeFilterCount}
            </span>
          </div>

          <div style={{ width: 1, height: 20, backgroundColor: '#d9d9d9', margin: '0 4px' }} />

          <AnimatePresence mode="popLayout">
            {filters.status && (
              <motion.div
                key="status"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2 }}
              >
                <div
                  className={`filter-chip ${removingFilter === 'status' ? 'filter-chip-exit' : ''}`}
                  style={{ borderColor: getStatusColor(filters.status) + '40', backgroundColor: getStatusColor(filters.status) + '10' }}
                  onClick={() => handleRemove('status')}
                >
                  <span style={{ color: getStatusColor(filters.status), fontWeight: 500, fontSize: 12 }}>
                    Durum: {statusOptions.find(opt => opt.value === filters.status)?.label || filters.status}
                  </span>
                  <CloseOutlined className="filter-chip-remove" style={{ color: getStatusColor(filters.status) }} />
                </div>
              </motion.div>
            )}

            {filters.customerIds && filters.customerIds.length > 0 && (
              <motion.div
                key="customer"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2, delay: 0.05 }}
              >
                <div
                  className={`filter-chip ${removingFilter === 'customerIds' ? 'filter-chip-exit' : ''}`}
                  style={{ borderColor: '#52c41a40', backgroundColor: '#f6ffed' }}
                  onClick={() => handleRemove('customerIds')}
                >
                  <span style={{ color: '#52c41a', fontWeight: 500, fontSize: 12 }}>
                    Müşteriler: {filters.customerIds.length} seçili
                  </span>
                  <CloseOutlined className="filter-chip-remove" style={{ color: '#52c41a' }} />
                </div>
              </motion.div>
            )}

            {filters.dateRange && filters.dateRange.length === 2 && (
              <motion.div
                key="date"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2, delay: 0.1 }}
              >
                <div
                  className={`filter-chip ${removingFilter === 'dateRange' ? 'filter-chip-exit' : ''}`}
                  style={{ borderColor: '#722ed140', backgroundColor: '#f9f0ff' }}
                  onClick={() => handleRemove('dateRange')}
                >
                  <span style={{ color: '#722ed1', fontWeight: 500, fontSize: 12 }}>
                    Tarih Araligi
                  </span>
                  <CloseOutlined className="filter-chip-remove" style={{ color: '#722ed1' }} />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </Space>

        {activeFilterCount > 1 && onClearAll && (
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Button
              type="text"
              size="small"
              icon={<ClearOutlined />}
              onClick={onClearAll}
              style={{ color: '#ff4d4f', fontSize: 12 }}
            >
              Tumunu Temizle
            </Button>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
};

export default ActiveFilters;
